import { createContext } from 'react';

import {
  UbiquitiApiDataItem,
  UbiquitiDnsPolicy,
} from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  error: boolean;
  dnsPolicies: UbiquitiApiDataItem<UbiquitiDnsPolicy>[];
}

export default createContext<Context>({
  loading: false,
  error: false,
  dnsPolicies: [],
});
